import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrderRefundPaymentEditPage } from 'src/app/modals/order-refund-payment-edit/order-refund-payment-edit.page';

const routes: Routes = [
  {
    path: '',
    component: OrderRefundPaymentEditPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrderRefundPaymentEditPage]
})
export class OrderRefundPaymentEditPageModule {}
